/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { SimulationStatusNameEnum } from "./SimulationStatusNameEnum";
import {
  SimulationStatusNameEnumFromJSON,
  SimulationStatusNameEnumFromJSONTyped,
  SimulationStatusNameEnumToJSON,
  SimulationStatusNameEnumToJSONTyped,
} from "./SimulationStatusNameEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedSimulationStatus
 */
export interface PatchedSimulationStatus {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  name?: SimulationStatusNameEnum;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   *
   */
  readonly simulationName?: string;
  /**
   *
   */
  readonly simulationUserEmail?: string | null;
  /**
   *
   */
  readonly simulationOrganisationUniqueId?: string;
  /**
   *
   */
  readonly simulationTags?: Array<string>;
  /**
   *
   */
  readonly simulationUserFirstName?: string;
  /**
   *
   */
  readonly simulationUserLastName?: string;
  /**
   *
   */
  readonly threedimodelSlug?: string;
  /**
   *
   */
  readonly threedimodelId?: number;
  /**
   *
   */
  readonly hasResults?: boolean | null;
  /**
   *
   */
  readonly created?: Date;
  /**
   *
   */
  readonly expiry?: Date | null;
  /**
   * simulation time in seconds
   */
  time?: number | null;
  /**
   *
   */
  paused?: boolean | null;
  /**
   *
   */
  detail?: any | null;
  /**
   *
   */
  exitCode?: number | null;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedSimulationStatus interface.
 */
export function instanceOfPatchedSimulationStatus(value: object): value is PatchedSimulationStatus {
  return true;
}

export function PatchedSimulationStatusFromJSON(json: any): PatchedSimulationStatus {
  return PatchedSimulationStatusFromJSONTyped(json, false);
}

export function PatchedSimulationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedSimulationStatus {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"] == null ? undefined : SimulationStatusNameEnumFromJSON(json["name"]),
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    simulationName: json["simulation_name"] == null ? undefined : json["simulation_name"],
    simulationUserEmail:
      json["simulation_user_email"] === undefined
        ? undefined
        : json["simulation_user_email"] === null
        ? null
        : json["simulation_user_email"],
    simulationOrganisationUniqueId:
      json["simulation_organisation_unique_id"] == null
        ? undefined
        : json["simulation_organisation_unique_id"],
    simulationTags: json["simulation_tags"] == null ? undefined : json["simulation_tags"],
    simulationUserFirstName:
      json["simulation_user_first_name"] == null ? undefined : json["simulation_user_first_name"],
    simulationUserLastName:
      json["simulation_user_last_name"] == null ? undefined : json["simulation_user_last_name"],
    threedimodelSlug: json["threedimodel_slug"] == null ? undefined : json["threedimodel_slug"],
    threedimodelId: json["threedimodel_id"] == null ? undefined : json["threedimodel_id"],
    hasResults:
      json["has_results"] === undefined
        ? undefined
        : json["has_results"] === null
        ? null
        : json["has_results"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    expiry:
      json["expiry"] === undefined
        ? undefined
        : json["expiry"] === null
        ? null
        : parseDateTime(json["expiry"]),
    time: json["time"] === undefined ? undefined : json["time"] === null ? null : json["time"],
    paused:
      json["paused"] === undefined ? undefined : json["paused"] === null ? null : json["paused"],
    detail:
      json["detail"] === undefined ? undefined : json["detail"] === null ? null : json["detail"],
    exitCode:
      json["exit_code"] === undefined
        ? undefined
        : json["exit_code"] === null
        ? null
        : json["exit_code"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedSimulationStatusToJSON(json: any): PatchedSimulationStatus {
  return PatchedSimulationStatusToJSONTyped(json, false);
}

export function PatchedSimulationStatusToJSONTyped(
  value?: Omit<
    PatchedSimulationStatus,
    | "url"
    | "simulation"
    | "simulationId"
    | "simulationName"
    | "simulationUserEmail"
    | "simulationOrganisationUniqueId"
    | "simulationTags"
    | "simulationUserFirstName"
    | "simulationUserLastName"
    | "threedimodelSlug"
    | "threedimodelId"
    | "hasResults"
    | "created"
    | "expiry"
    | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: SimulationStatusNameEnumToJSON(value["name"]),
    time: value["time"],
    paused: value["paused"],
    detail: value["detail"],
    exit_code: value["exitCode"],
  };
}
